import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DataLoaderService } from '../services/data-loader.service';
import { forkJoin, of, catchError } from 'rxjs';

export const dataStoreResolver: ResolveFn<any> = (route, state) => {
  const dataLoader = inject(DataLoaderService);
  const apiCallList = dataLoader.loadEntityData(state.url);

  if (apiCallList && Object.keys(apiCallList).length)
    return forkJoin(apiCallList).pipe(
      catchError(error => {
        console.error('Data Resolver : loading failed', error);
        return of(true);
      })
    );
  return of(true);
};
